const query = (id, data) => {
    return fetch(`/domains/${id}/refresh/`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'X-CSRFToken': window.csrf_token,
        },
        body: JSON.stringify(data),
    });
};

export default query;
